import { PanelSection, Timeline } from '@dev-spendesk/grapes';

import { useTranslation } from 'src/core/common/hooks/useTranslation';

import { type TimelineEvent, TimelineItem } from './TimelineItem';

export const PanelSectionTimeline = ({
  title,
  events,
}: {
  title: string;
  events: TimelineEvent[];
}) => {
  const { t } = useTranslation('global');
  return (
    <PanelSection title={title}>
      {events.length ? (
        <Timeline>
          {events.map((timelineEvent) => (
            <TimelineItem
              key={timelineEvent.id}
              timelineEvent={timelineEvent}
            />
          ))}
        </Timeline>
      ) : (
        <span className="text-content-secondary-bg-primary">
          {t('common.timeline.events.noEvents')}
        </span>
      )}
    </PanelSection>
  );
};
